import api from '../utils/api'

function authHeader() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${JSON.parse(token)}` } : {};
}

// Envia a planilha mensal de movimentações (36 meses). `file` é um File do input.
export const uploadPlanilha = async (file) => {
    try {
        const formData = new FormData();
        formData.append('planilha', file);
        const { data } = await api.post('/movimentacoes36/upload', formData, {
            headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
        });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao enviar a planilha.');
    }
}

// Metadados do último upload → { lastUpload: { originalName, totalItens, userName, uploadedAt } | null }
export const getLastUpload = async () => {
    try {
        const { data } = await api.get('/movimentacoes36/last-upload', { headers: authHeader() });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao buscar último upload.');
    }
}

// Movimentações de um código SAP → { movimentacao: { movDRS, ... } | null }
export const getByCodSap = async (codSap) => {
    try {
        const { data } = await api.get(`/movimentacoes36/codsap/${encodeURIComponent(codSap)}`, { headers: authHeader() });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao buscar movimentações.');
    }
}

const Movimentacao36Service = { uploadPlanilha, getLastUpload, getByCodSap };
export default Movimentacao36Service;
